import Party from './Party'
import PartyResult from './PartyResult'

class Coalition {
  protected _mainPartyResult: PartyResult
  protected _secondaryPartyResults: PartyResult[]

  public static fromPartyResultList(partyResultList: PartyResult[]): Coalition {
    const mainParty = partyResultList[0]
    const otherParties = partyResultList
      .slice(1, partyResultList.length)
      .filter((partyResult): boolean => partyResult.seatCount > 0)
    return new Coalition(mainParty, otherParties)
  }

  public constructor(
    mainParty: PartyResult,
    secondaryPartiesByVotes: PartyResult[]
  ) {
    this._mainPartyResult = mainParty
    this._secondaryPartyResults = secondaryPartiesByVotes
  }

  public get mainParty(): Party {
    return this._mainPartyResult.party
  }

  public get secondaryPartiesByVotes(): Party[] {
    return this._secondaryPartyResults.map(
      (partyResult): Party => partyResult.party
    )
  }

  public get secondaryPartiesByKeys(): Party[] {
    return this.secondaryPartiesByVotes.sort((a, b): number =>
      a.key.localeCompare(b.key)
    )
  }

  public get stringRepresentation(): string {
    return `${this.mainParty.key}-${this.secondaryPartiesByVotes
      .map((party): string => party.key)
      .join('-')}`
  }

  public get uniqueStringRepresentation(): string {
    const allParties = [this.mainParty]
      .concat(this.secondaryPartiesByKeys)
      .sort()
    return allParties.map((party): string => party.key).join('-')
  }

  public getParent(): Coalition | null {
    if (this._secondaryPartyResults.length === 1) return null
    return new Coalition(
      this._mainPartyResult,
      this._secondaryPartyResults.slice(
        0,
        this._secondaryPartyResults.length - 1
      )
    )
  }

  // public static countByMainParty(
  //   coalitions: Coalition[]
  // ): { [key: string]: number } {}
}

export default Coalition
